import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../api';

export default function Policies() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api('/policies/published').then(r => r.ok ? r.json() : []).then(setDocuments).finally(() => setLoading(false));
  }, []);

  const handleDownload = async (docId) => {
    const res = await api(`/policies/published/${docId}/url`);
    if (res.ok) {
      const data = await res.json();
      window.open(data.url, '_blank');
    }
  };

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Company Policies</h2>

      {loading ? <p className="text-gray-500">Loading...</p> : documents.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg shadow">
          <p className="text-gray-500">No policies available.</p>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow divide-y divide-gray-200">
          {documents.map(doc => (
            <div key={doc.id} className="flex items-center justify-between p-4 hover:bg-gray-50">
              <div className="flex items-center gap-3 min-w-0">
                <svg className="w-5 h-5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">{doc.fileName}</p>
                  <p className="text-xs text-gray-500">{doc.createdAt ? new Date(doc.createdAt).toLocaleDateString() : ''}</p>
                </div>
              </div>
              <button onClick={() => handleDownload(doc.id)}
                className="text-sm text-indigo-600 hover:text-indigo-800 font-medium flex-shrink-0">
                Download
              </button>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
